export enum RateType {
  Hourly = 'Hourly',
  Fixed = 'Fixed',
}

export enum RateStatus {
  Active = 'Active',
  Archived = 'Archived',
  All = 'All',
}

export interface IRate {
  id: string;
  idUser: string;
  name: string;
  description: string;
  amountExclGst: number;
  amountGst: number;
  amountInclGst: number;
  rateType: string;
  isArchived: boolean;

  expanded: boolean;
  // Derived from isArchived
  status?: string;
}
